<script>
// import {isEmpty} from "@/utils/stringUtils";

export default {
  name: "Content",
  data() {
    return {
      bannerImg: require("@/assets/img/banner.png"),
      fly: require("@/assets/img/fly.png"),
      usaex: require("@/assets/img/usaex.png"),
      house: require("@/assets/img/house.png"),
      about: require("@/assets/img/about-img.jpg"),
      form: {
        waybillNo: '',
        name: '',
        email: '',
        title: '',
        substance: ''
      }
    }
  },
  methods: {
    handleSearch() {
      let waybillNo = this.form.waybillNo;

      this.$router.push({name: 'trackResult',
        params:{
          waybillNo:  waybillNo}}
      );
      this.resetWaybillNo();
    },
    onSubmit() {
      this.$message.success('成功');
      this.resetSubstance();
    },
    resetSubstance() {
      this.$set(this.form, 'name', '');
      this.$set(this.form, 'email', '');
      this.$set(this.form, 'title', '');
      this.$set(this.form, 'substance', '');
    },
    resetWaybillNo() {
      this.$set(this.form, 'waybillNo', '');
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   const hash = window.location.hash;
    //   if (isEmpty(hash)) {
    //     return;
    //   }
    //   const element = this.$el.querySelector(hash);
    //   if (element) {
    //     element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动
    //   }
    // });
  }
}
</script>

<template>

  <div id="subject">
    <div>
      <img id="banner" :src="bannerImg" alt="banner">
    </div>
    <div class="content-body">
      <div class="custom-form">
        <el-form :inline="true" :model="form" class="form-inline">
          <el-form-item label="输入报关单号:" prop="waybillNo">
            <el-input v-model="form.waybillNo" size="large" placeholder="请输入报关单号"></el-input>
          </el-form-item>
          <el-button type="primary" size="large" @click="handleSearch">查询</el-button>
        </el-form>
      </div>
      <div id="headerDivider">
        <el-divider></el-divider>
      </div>
      <div id="weServe">
        <el-divider direction="vertical"></el-divider>
        <span>我们的服务</span>
      </div>
      <el-row id="service" :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <i class="fa">
              <img :src="fly" alt="fly">
            </i>
            <h3>公司介绍</h3>
            <p>公司致力于打造中国最大、最专业的国内空运、中港进出口、代理报关、清关、商检、国际空运、国际快递、国际进出口企业。</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <i class="fa">
              <img :src="usaex" alt="usaex">
            </i>
            <h3>我的服务</h3>
            <p>公司高覆盖、高效率的服务获得多家公司和机构的认可,拥有庞大的合作快递公司落地派服务网点。</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <i class="fa">
              <img :src="house" alt="house">
            </i>
            <h3>产品介绍</h3>
            <p>根据客户寄递需求，与国内国际知名快递企业长期合作，资源互补，以最快速度申报清关完成中转和派送的高品质国际快件服务。</p>
          </div>
        </el-col>
      </el-row>
      <div id="weAbout">
        <span>关于我们</span>
        <el-divider direction="vertical"></el-divider>
      </div>
      <el-row id="about" :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
              <img :src="about" alt="about">
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <p>深圳市和安国际货运代理有限公司于2004年05月12日在深圳市市场监督管理局登记成立。
              公司经营范围包括兴办实业；国内空运 中港进出口 代理报关 清关 商检 国际空运 国际快递
              国际进出口 进出口代理 国内贸易。承办空运进出口货物的国际运输代理业务等。</p>
            <p>公司将以最专业的精神为您提供安全、和安国际始终坚持以客户服务为核心，秉承“客户至上、
              服务为先”的宗旨，努力为客户创造更大价值，实现双方共赢，拥有一支朝气蓬勃且专业高效的团队，
              以全面的网络、高效的速度、优质的服务打造核心竞争优势，力争成为跨境电商行业的领航者。</p>
          </div>
        </el-col>
      </el-row>
      <div id="aboutDivider">
        <el-divider></el-divider>
      </div>
      <div id="weContact">
        <span>联系我们</span>
        <el-divider direction="vertical"></el-divider>
      </div>
      <div id="formDiv">
        <el-form ref="form" :model="form" >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item >
                <el-input v-model="form.name" placeholder="姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item >
                <el-input v-model="form.email" placeholder="邮箱"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item>
                <el-input v-model="form.title" placeholder="标题"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-input type="textarea" v-model="form.substance" placeholder="留言内容"></el-input>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button type="primary" @click="onSubmit()">提交留言</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div id="formDivider">
        <span style="display: block; text-align: left">联系电话：0755-27770383</span>
        <el-divider></el-divider>
        <span style="display: block; text-align: center">Copyright © 2018 深圳和安国际货运代理有限公司</span>
        <a style="display: block; text-align: center" href="https://beian.miit.gov.cn" target="_blank">粤ICP备2024331967号-1</a>
      </div>
    </div>
  </div>

</template>

<style scoped>

#banner {
  height: 550px;
  min-height: 450px;
  width: 100%;
  position: relative;
}

.custom-form {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
//height: 20%; /* 根据需要调整高度 */
}

#headerDivider {
  padding-top: 2.5%;
  padding-bottom: 2.5%;
}

#headerDivider .el-divider {
  margin: 0;
  background-color: #974576;
  //width: 80%;
  top: 50%; /* 将内容的顶部设置在容器的中心 */
  left: 50%; /* 将内容的左边设置在容器的中心 */
  transform: translate(-50%, -50%); /* 使用变换将内容自身的中心移动到之前设置的中心点上 */
}


#aboutDivider {
  padding-top: 2.5%;
  padding-bottom: 2.5%;
}

#aboutDivider .el-divider {
  padding-top: 0.5%;
  margin: 0;
  background-color: #974576;
  //line-height: 10px;
  //width: 80%;
  //top: 50%; /* 将内容的顶部设置在容器的中心 */
  //left: 50%; /* 将内容的左边设置在容器的中心 */
  //transform: translate(-50%, -50%); /* 使用变换将内容自身的中心移动到之前设置的中心点上 */
}

#formDivider {
  padding-bottom: 2.5%;
}

#formDivider .el-divider {
  padding-top: 0.1%;
  margin: 0;
  background-color: #974576;

}





#formDiv {
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 2%;
}

#formDiv .el-button {
  color: #FFF;
  background-color: #444;
  border-color: #444;
  width: 180px;
  min-width: 120px;
  float: right;
}

.content-body {
  padding-left: 15%;
  padding-right: 15%;
  padding-top: 2%;
}

#weServe .el-divider {
  background-color: #974576;
  height: 50px;
  width: 4px;
}

#weServe span {
  font-size: 23px;
  font-weight: 950;
  padding-left: 2%;
}

#weAbout {
  padding-left: 45%;
}

#weAbout .el-divider {
  background-color: #974576;
  height: 50px;
  width: 4px;
}

#weAbout span {
  font-size: 23px;
  font-weight: 950;
  padding-right: 3%;
}

#weContact {
  padding-left: 45%;
}

#weContact .el-divider {
  background-color: #974576;
  height: 50px;
  width: 4px;
}

#weContact span {
  font-size: 23px;
  font-weight: 950;
  padding-right: 3%;
}



.form-inline {
  text-align: left; /* 根据需要调整文本对齐方式 */
}

.custom-form /deep/ .el-input__inner {
  width: 450px
}

/deep/ .el-input__inner:focus {
  border-color: #974576; /* 你可以设置为任何你想要的颜色 */
  outline: none; /* 移除默认的浏览器轮廓 */
}

/deep/ .el-textarea__inner:focus {
  border-color: #974576; /* 你可以设置为任何你想要的颜色 */
  outline: none; /* 移除默认的浏览器轮廓 */
}

/deep/ .el-form-item__label {
  font-size: 18px;
  font-weight: 700;
  color: black;
}

/deep/ .el-button--large {
  background: none;
  color: black;
  border: 1px solid #974576;
}

/deep/ .el-button--large:not(:hover) {
  background: none;
  color: black;
  border: 1px solid #974576;
}

/deep/ .el-button--large:hover {
  background-color: #974576; /* 鼠标悬停时的背景颜色 */
}


.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
  padding-top: 2%;
  //border: 1px solid #974576;
}

#service img {
  width: 120px;
  height: 120px;
}

#service .fa {
  border-top: 3px solid #f2af00;
  border-bottom: 3px solid #dc5034;
  border-radius: 50%;
  font-size: 32px;
  color: #dc5034;
  text-align: center;
  vertical-align: middle;
  margin-top: 20px;
  margin-bottom: 8px;
  padding: 10px;
  display: inline-block;
  font: normal normal normal 14px / 1 FontAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transform: translate(0, 0);
  box-sizing: border-box;
}

#about img {
  border: 1px solid #cccccc;
  padding: 5px;
  //width: 50%;
  display: block;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  box-sizing: border-box;
  overflow-clip-margin: content-box;
  overflow: clip;
}

</style>
